import { HrmsEmpDetService, RmBudgetServices, SuppliersService, UnitcodeService, VehicleService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HLpercentagesService } from 'libs/shared-services/masters/src/lib/hl-percentages-service';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { GrnAdapter } from './dto/raw-material-grn.adapter';
import { RawMaterialGrnController } from './raw-material-grn.controller';
import { Grn } from './raw-material-grn.entity';
import { RawMaterialGrnService } from './raw-material-grn.service';
import { LotCodeOpsService, ProdInvService, ProductionInventoryService, ProdlogService } from '@gtpl/shared-services/production';
import { VehicleInspectionController } from './vehicle-inspection/vehicle-inspection.controller';
import { VehicleInspectionService } from './vehicle-inspection/vehicle-inspection.service';
import { VehicleAssignmentService } from '@gtpl/shared-services/transportation';
import { VehicleInspectionRepository } from './vehicle-inspection.repository';
import { VehicleInspectionAdapter } from './dto/vehicle-inspection-adapter';
import { RmEvaluationService } from './rm-evaluation/rm-evaluation.service';
import { RmEvaluationSamplesAdapter } from './dto/rm-evaluation-samples.adapter';
import { RmEvaluationAdapter } from './dto/rm-evaluation.adapter';
import { RmEvaluationController } from './rm-evaluation/rm-evaluation.controller';
import { RmEvaluationSamples } from './rm-evaluation-samples.entity';
import { RmEvaluation } from './rm-evaluation.entity';
import { RmEvaluationRepository } from './rm-evaluation.repository';
import { RmAntiBioticsAdapter } from './dto/rm-antibiotics-report.adapter';
import { RmAntiBioticsRepository } from './rm-antibiotics-report.respository';
import { AntibioticsReportService } from './antibiotics-microbiology-report/rm-antibiotics-report.service';
import { AnitibioticsReportController } from './antibiotics-microbiology-report/rm-antibiotics-report.controller';
import { RmAntiBioticsTest } from './rm-antibiotics-report.entity';
import { ProductService } from '@gtpl/shared-services/masters';
import { GrnItems } from './raw-material-grn-items.entity';
import { GrnItemDefects } from './grn-item-defects.entity';
import { RmCountRanges } from './rm-count-pricelist-entity';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { RMReWeighingEntity } from '../indent/rm-re-weighing/rm-re-weighing.entity';
import { EnquiriesService } from '@gtpl/shared-services/enquiry-management';
import {RmCountPriceListService} from '@gtpl/shared-services/raw-material-procurement'

@Module({
  imports: [
    TypeOrmModule.forFeature([Grn, GrnItems, VehicleInspectionRepository, RmEvaluationSamples, RmEvaluation, RmEvaluationRepository, RmAntiBioticsRepository, RmAntiBioticsTest, GrnItemDefects,RmCountRanges,RMReWeighingEntity]),
    // forwardRef(() => ClusterModule),
  ],

  controllers: [RawMaterialGrnController, VehicleInspectionController, RmEvaluationController, AnitibioticsReportController],
  providers: [RawMaterialGrnService, GrnAdapter, ApplicationExceptionHandler, SaleOrderService, HLpercentagesService, SuppliersService, IndentService, ProdInvService, LotCodeOpsService, ProductionInventoryService, ProdlogService, UnitcodeService, VehicleInspectionService, VehicleAssignmentService, VehicleService, VehicleInspectionAdapter, RmEvaluationService, RmEvaluationSamplesAdapter, RmEvaluationAdapter, RmAntiBioticsAdapter, AntibioticsReportService, ProductService,LogsService,HrmsEmpDetService,EnquiriesService,RmCountPriceListService,RmBudgetServices],
  exports: [RawMaterialGrnService, VehicleInspectionService, RmEvaluationService, AntibioticsReportService],
})
export class RawMaterialGrnModule { }
